import { createAction, props } from '@ngrx/store';
import { AlarmsManagerModel } from '../../models/alarms-manager.model';

export const resetToInitialState = createAction('[ALARMS MANAGER] Reset to Initial state');

// Load Alarms with pagination and filters
export const getAlarms = createAction('[ALARMS MANAGER] Get alarms',
  props<{ query?: AlarmsManagerModel.GetAlarmsQuery }>()
);
export const getAlarmsSuccess = createAction('[ALARMS MANAGER] Get alarms Success',
  props<{ response: AlarmsManagerModel.AlarmListResponse }>()
);
export const getAlarmsFail = createAction('[ALARMS MANAGER] Get alarms Fail',
  props<{ error: string }>()
);

// Get Alarm Details
export const getAlarmById = createAction('[ALARMS MANAGER] Get alarm by ID',
  props<{ alarmId: number }>()
);
export const getAlarmByIdSuccess = createAction('[ALARMS MANAGER] Get alarm by ID Success',
  props<{ alarm: AlarmsManagerModel.Alarm }>()
);
export const getAlarmByIdFail = createAction('[ALARMS MANAGER] Get alarm by ID Fail',
  props<{ error: string }>()
);

// Get Alarm with Alerts
export const getAlarmWithAlerts = createAction('[ALARMS MANAGER] Get alarm with alerts',
  props<{ alarmId: number }>()
);
export const getAlarmWithAlertsSuccess = createAction('[ALARMS MANAGER] Get alarm with alerts Success',
  props<{ alarmWithAlerts: AlarmsManagerModel.AlarmWithAlerts }>()
);
export const getAlarmWithAlertsFail = createAction('[ALARMS MANAGER] Get alarm with alerts Fail',
  props<{ error: string }>()
);

// Close Alarm
export const closeAlarm = createAction('[ALARMS MANAGER] Close alarm',
  props<{ alarmId: number; userId: string }>()
);
export const closeAlarmSuccess = createAction('[ALARMS MANAGER] Close alarm Success',
  props<{ alarmId: number }>()
);
export const closeAlarmFail = createAction('[ALARMS MANAGER] Close alarm Fail',
  props<{ error: string }>()
);

// Get Alarm Statistics
export const getAlarmStats = createAction('[ALARMS MANAGER] Get alarm stats');
export const getAlarmStatsSuccess = createAction('[ALARMS MANAGER] Get alarm stats Success',
  props<{ stats: AlarmsManagerModel.AlarmStatsResponse }>()
);
export const getAlarmStatsFail = createAction('[ALARMS MANAGER] Get alarm stats Fail',
  props<{ error: string }>()
);

// Check Timeouts
export const checkTimeouts = createAction('[ALARMS MANAGER] Check timeouts');
export const checkTimeoutsSuccess = createAction('[ALARMS MANAGER] Check timeouts Success',
  props<{ updatedCount: number }>()
);
export const checkTimeoutsFail = createAction('[ALARMS MANAGER] Check timeouts Fail',
  props<{ error: string }>()
);

// UI State
export const setAlarmsLoading = createAction('[ALARMS MANAGER] Set Alarms Loading',
  props<{ isLoading: boolean }>()
);

export const setSelectedAlarm = createAction('[ALARMS MANAGER] Set Selected Alarm',
  props<{ alarm: AlarmsManagerModel.Alarm | null }>()
);

export const clearSelectedAlarmWithAlerts = createAction('[ALARMS MANAGER] Clear Selected Alarm With Alerts');

export const setAlarmFilter = createAction('[ALARMS MANAGER] Set Alarm Filter',
  props<{ filter: AlarmsManagerModel.GetAlarmsQuery }>()
);

export const setCurrentPage = createAction('[ALARMS MANAGER] Set Current Page',
  props<{ page: number }>()
);